export default "__VITE_ASSET__L$AwL5px__"